import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChatflowHoliday, ChatflowHolidayRequest } from '../models/chatflow-holiday.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatflowHolidayApiService {
  private readonly base = `${environment.apiUrl}api/chatflows`;

  constructor(private http: HttpClient) {}

  getHolidays(chatflowId: number): Observable<ChatflowHoliday[]> {
    return this.http.get<ChatflowHoliday[]>(`${this.base}/${chatflowId}/holidays`);
  }

  createHoliday(chatflowId: number, holiday: ChatflowHolidayRequest): Observable<ChatflowHoliday> {
    return this.http.post<ChatflowHoliday>(`${this.base}/${chatflowId}/holidays`, holiday);
  }

  updateHoliday(chatflowId: number, holidayId: number, holiday: ChatflowHolidayRequest): Observable<ChatflowHoliday> {
    return this.http.put<ChatflowHoliday>(`${this.base}/${chatflowId}/holidays/${holidayId}`, holiday);
  }

  deleteHoliday(chatflowId: number, holidayId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${chatflowId}/holidays/${holidayId}`);
  }
}
